module.exports = __webpack_public_path__ + "assets/2f2eca656bb452d0d366c2887fb0e1aa.png";